import { FC } from 'react';
import { BsCurrencyPound } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { TSTitleCard } from '../../../../components/shared/card/Card';
import { ReadEmployee } from '../../../../services/gql/graphql.generated';
import strings from '../../team.translations';

interface TeamMemberPayCardProps {
  enableEdit?: boolean;
  employee: ReadEmployee;
}

export const TeamMemberPayCard: FC<TeamMemberPayCardProps> = ({ employee, enableEdit }) => {
  const navigate = useNavigate();
  const onEditClick = () => {
    navigate(`/team-member/${employee.identityId}/edit-details/true`);
  };

  return (
    <TSTitleCard
      title={strings.memberPayCard.cardTitle}
      className="h-full"
      icon={BsCurrencyPound}
      primaryAction={
        enableEdit
          ? {
              label: strings.memberPayCard.editLabel,
              onClick: onEditClick
            }
          : undefined
      }
    >
      <div className="pt-4">
        <div className="font-semibold">{strings.memberPayCard.hourlyRate}</div>
        <p>{strings.memberPayCard.noPaySet}</p>
      </div>
    </TSTitleCard>
  );
};
